
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bundles/shop",
      function () {
        return require("private-next-pages/bundles/shop/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/bundles/shop"])
      });
    }
  